import { useState, useEffect } from "react";
import { useParams } from "react-router";
import fetchData from "utils/fetchData";
import { NavLink } from "react-router-dom";
import SelectItems from "components/SelectItems";
import EditView from "components/EditView";

const Referent = () => {
    const { id } = useParams();
    const [referent, setReferent] = useState(null);
    const [clients, setClients] = useState([]);
    const [clientsRef, setClientsRef] = useState([]);
    const [foldersRef, setFoldersRef] = useState([]);
    const [folders, setFolders] = useState([]);

    const columns = [
        {
            key: "name",
            label: "Nom du référent"
        },
        {
            key: "email",
            label: "Email du référent"
        },
        {
            key: "password",
            label: "Mot de passe du référent"
        }
    ]

    useEffect(() => {
        const get_user = async () => {
            const { data, error } = await fetchData({
                url: "users/" + id
            });
            if (!error) {
                for (const [key, value] of Object.entries(data)) {
                    if (!value) data[key] = "";
                }
                setReferent(data);
            }
        }

        const get_clients = async () => {
            const { data, error } = await fetchData({
                url: "users?roles_id=1"
            });

            if (!error) setClients(data.map(d => ({ value: d.id, label: d.name })));
        }

        const get_clients_ref = async () => {
            const { data, error } = await fetchData({
                url: "referents-clients?referents_id=" + id
            });
            if (!error) setClientsRef([...data.map(d => ({ value: d.client.id, label: d.client.name }))]);
        }

        const get_folders = async () => {
            const { data, error } = await fetchData({
                url: "folders?root=true"
            });

            if (!error) setFolders(data.map(d => ({ value: d.id, label: d.name })));
        }

        const get_folders_ref = async () => {
            const { data, error } = await fetchData({
                url: "referents-folders?referents_id=" + id
            });
            if (!error) setFoldersRef([...data.map(d => ({ value: d.folders.id, label: d.folders.name }))]);
        }

        get_folders_ref();
        get_folders();
        get_clients_ref();
        get_clients();
        get_user()
    }, [id]);

    const post_client = async (obj) => {
        const { data, error } = await fetchData({
            url: 'users/' + id,
            method: "put",
            body: obj
        });

        return (!(Boolean(error)));
    }

    const addRef = async (obj) => {
        const { data, error } = await fetchData({
            url: "referents-clients",
            method: "post",
            body: {
                referents_id: id,
                clients_id: obj.value,
            },
            message: "Le client a bien été attribué au référent"
        });
        return !Boolean(error) 
    }

    const destroyRef = async (obj) => {
        const { data, error } = await fetchData({
            url: "referents-clients",
            method: "delete",
            body: {
                referents_id: id,
                clients_id: obj.value,
            },
            message: "Le client a bien été supprimé du référent"
        });
        return !Boolean(error) 
    }

    const addFoldersRef = async (obj) => {
        const { data, error } = await fetchData({
            url: "referents-folders",
            method: "post",
            body: {
                referents_id: id,
                folders_id: obj.value
            },
            message: "Le dossier a bien été attribué du référent"
        });
        return !Boolean(error) 
    }

    const destroyFoldersRef = async (obj) => {
        const { data, error } = await fetchData({
            url: "referents-folders",
            method: "delete",
            body: {
                referents_id: id,
                folders_id: obj.value
            },
            message: "Le dossier a bien été supprimé du référent"
        });
        return !Boolean(error) 
    }

    if (!referent) return <></>

    return <div className="page">
        <main>

            <div className="container">
                <form style={{ alignItems: "stretch", padding: "10px 20px"}} className="card">
                    <span>
                        <h3>{referent.name}</h3>
                        <NavLink to="/referent"><button>Retour</button></NavLink>
                    </span>
                </form>

                <form className="card">
                    <div className="group">
                        <label>Clients du référent</label>
                        <SelectItems add={addRef} destroy={destroyRef} dataset={clients} items={clientsRef} setItems={setClientsRef} />
                    </div>
                    <div className="group">
                        <label>Dossier du référent</label>
                            <SelectItems add={addFoldersRef} destroy={destroyFoldersRef} dataset={folders} items={foldersRef} setItems={setFoldersRef} />
                        </div>
                </form>
                <EditView columns={columns} setItem={setReferent} item={referent} post={post_client} />
            </div>
        </main>
    </div>
}

export default Referent;